import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { spacing } from 'ui/theme';
import { Skeleton } from 'ui/skeleton';
import { ImageDetailsContainer, StyledCard, PreviewContainer } from './CardItem';

const Grid = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(${pxToRem(304)}, 1fr));
  grid-template-rows: 1fr;
  grid-column-gap: ${spacing.plusHalf};
  grid-row-gap: ${spacing.plusHalf};
  grid-auto-flow: row;
  margin-bottom: 0;
  padding: ${spacing.plusHalf} ${spacing.double};
`;

const NameSkeleton = styled(Skeleton)`
  width: ${spacing.x16};
  height: ${spacing.plusQuarter};
  margin-bottom: ${spacing.half};
`;

const AdditionalDetailsSkeleton = styled(Skeleton)`
  width: ${spacing.x12};
  height: ${spacing.base};
`;

const skeletonCards = 20;

export const testId = 'cl-cards-skeleton';

export const CardsSkeleton = () => (
  <Grid data-test={testId}>
    {Array(skeletonCards)
      .fill({})
      .map((c, i) => (
        <StyledCard key={`skeleton-card-${i}`}>
          <PreviewContainer>
            <Skeleton />
          </PreviewContainer>
          <ImageDetailsContainer>
            <NameSkeleton />
            <AdditionalDetailsSkeleton />
          </ImageDetailsContainer>
        </StyledCard>
      ))}
  </Grid>
);
